import api from "./api";

const unwrap = (res) => res?.data ?? null;

const API_URL = "/DigitalTwinShipment";

export const getDigitalTwinByShipmentId = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/shipment/${shipmentId}`));

export const getDigitalTwinByTrackingNumber = async (trackingNumber) =>
    unwrap(
        await api.get(
            `${API_URL}/tracking/${encodeURIComponent(trackingNumber)}`
        )
    );

export const getDigitalTwinTelemetry = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/${shipmentId}/telemetry`));

export const getDigitalTwin = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/${shipmentId}`));

export const getClientDigitalTwin = async (shipmentId) =>
    unwrap(await api.get(`${API_URL}/client/${shipmentId}`));

export const createDigitalTwin = async (shipmentId) =>
    unwrap(await api.post(`${API_URL}/create/${shipmentId}`));

export const createAllDigitalTwins = async () =>
    unwrap(await api.post(`${API_URL}/create-all`));

export const updateDigitalTwinTelemetry = async (shipmentId, payload) =>
    unwrap(await api.post(`${API_URL}/${shipmentId}/telemetry`, payload));

export const updateDigitalTwinSecurityStatus = async (shipmentId, payload) =>
    unwrap(await api.post(`${API_URL}/${shipmentId}/security-status`, payload));

export const updateDigitalTwinThreatPrediction = async (shipmentId, payload) =>
    unwrap(await api.post(`${API_URL}/${shipmentId}/threat-prediction`, payload));

export default {
    getDigitalTwinByShipmentId,
    getDigitalTwinByTrackingNumber,
    getDigitalTwinTelemetry,
    getDigitalTwin,
    getClientDigitalTwin,
    createDigitalTwin,
    createAllDigitalTwins,
    updateDigitalTwinTelemetry,
    updateDigitalTwinSecurityStatus,
    updateDigitalTwinThreatPrediction,
};